import { render, staticRenderFns } from "./WebApp.vue?vue&type=template&id=2fdfe26d&scoped=true&"
import script from "./WebApp.vue?vue&type=script&lang=js&"
export * from "./WebApp.vue?vue&type=script&lang=js&"
import style0 from "./WebApp.vue?vue&type=style&index=0&id=2fdfe26d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdfe26d",
  null
  
)

export default component.exports